import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'

import './styles/index.css';
import AppContainer from './containers/AppContainer';
// import reportWebVitals from './reportWebVitals';
import store from './state';

ReactDOM.render(
  <React.StrictMode>
    {/* @ts-ignore */}
    <Provider store={store}>
      <AppContainer />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();